import { content } from "../../data/content";
import { useThemeContext } from "../../context/ThemeContext";
import { Card } from "../../components/Card/Card";
import { Shape } from "../../components/Shape/Shape";
import { Breadcrumb } from "../../components/Breadcrumb/Breadcrumb";
import styles from "./NowPage.module.scss";

const SHAPES = ["circle", "squircle", "pill", "blob", "circle"] as const;

export function NowPage() {
  const theme = useThemeContext();
  const c = content;
  const palette = [theme.acc, theme.moss, theme.rose, theme.butter, theme.sky];

  return (
    <>
      <section className={styles.hero}>
        <Breadcrumb
          theme={theme}
          breadcrumbs={[
            ["home", "home"],
            ["now", "now"],
          ]}
        />
        <h1 className={styles.h1} style={{ color: theme.fg }}>
          /now
        </h1>
        <p className={styles.lede} style={{ color: theme.muted }}>
          {c.nowLong.intro}
        </p>
        <div className={styles.updatedAt} style={{ color: theme.muted }}>
          <span className={styles.dot} style={{ background: theme.acc }} />
          last updated · {c.nowLong.updatedAt}
        </div>
      </section>

      <section className={styles.grid}>
        {c.nowLong.sections.map((sec, i) => (
          <Card theme={theme} key={i}>
            <div className={styles.secHeader}>
              <Shape
                kind={SHAPES[i % SHAPES.length]}
                color={palette[i % palette.length]}
                size={22}
              />
              <h3 className={styles.secTitle}>{sec.title}</h3>
            </div>
            <ul className={styles.list}>
              {sec.items.map((item, j) => (
                <li
                  key={j}
                  className={styles.listItem}
                  style={{
                    borderBottomColor:
                      j === sec.items.length - 1 ? "transparent" : theme.rule,
                  }}
                >
                  <span style={{ color: theme.acc, flexShrink: 0 }}>·</span>
                  <span style={{ color: theme.fg, opacity: 0.88 }}>{item}</span>
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </section>
    </>
  );
}
